import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

export type LogoVariant = 'wordMark' | 'glyph';

export interface LogoProps {
  variant?: LogoVariant;
  height?: number;
  /** Tenant override. Undefined = the Alison SVGs. */
  src?: string;
  alt?: string;
}

const SOURCES: Record<LogoVariant, string> = {
  wordMark: '/alison-wordmark.svg',
  glyph: '/alison-favicon.svg',
};

export function Logo({
  variant = 'wordMark',
  height,
  src,
  alt = 'alison.ai',
}: LogoProps): ReactNode {
  const resolvedHeight = height ?? (variant === 'wordMark' ? 30 : 24);
  return (
    <Box
      component="img"
      src={src ?? SOURCES[variant]}
      alt={alt}
      sx={{
        height: resolvedHeight,
        width: 'auto',
        display: 'block',
      }}
    />
  );
}
